<template>
  <div class="cpm-wrapper" v-show="showPreview">
    <div class="cpm-body">
      <div v-if="imgSrc.length" class="img-wrapper">
        <div v-if="imgSrc[index].url.includes('.pdf') || imgSrc[index].url.includes('.PDF')" class="demo-pdf">
          <img
            @click="openPdf(imgSrc[index].url)"
            style="cursor: pointer; border: 1px solid #D9D9D9; background: #EEEEEE; border-radius: 3px;"
            :src="require(`@/assets/img/pdf.svg`)"
          />
        </div>
        <img v-else class="demo-img" :src="imgSrc[index].url" alt="" />
        <span class="view-top">({{ index + 1 }}/{{ length }})</span>
        <img class="close-icon" @click="onCloseImg" :src="require('@/assets/img/circle-black-close-icon.png')" alt="" />
        <span v-if="imgSrc.length > 1" @click="showPrev" class="el-image-viewer__btn el-image-viewer__prev">
          <i class="el-icon-arrow-left"></i>
        </span>
        <span v-if="imgSrc.length > 1" @click="showNext" class="el-image-viewer__btn el-image-viewer__next">
          <i class="el-icon-arrow-right"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPreview: false,
      index: 0,
      length: 1,
      imgSrc: []
    };
  },
  mounted() {},
  methods: {
    show(func) {
      this.showPreview = true;
      this.imgSrc = this.urls;
      this.length = this.imgSrc.length;
      typeof func === 'function' && func.call(this, this);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onCloseImg() {
      this.resolve('hide');
      this.hide();
    },
    showPrev() {
      if (this.index === 0) return;
      this.index = this.index - 1;
    },
    showNext() {
      if (this.index === this.length - 1) return;
      this.index = this.index + 1;
    },
    openPdf(pdf) {
      window.open(pdf);
    },
    hide() {
      this.showPreview = false;
      document.body.removeChild(this.$el);
      this.$destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-body {
    .img-wrapper {
      z-index: 999999999 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: rgba($color: #000000, $alpha: 0.2);
      .demo-img {
        max-height: 671px;
        max-width: 1140px;
      }
      .view-top {
        margin-top: 24px;
        color: #595959;
      }
      .close-icon {
        cursor: pointer;
        width: 32px;
        height: 32px;
        margin-top: 24px;
      }
    }
  }
}
</style>
